import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import FormField from "../../../layouts/ecommerce/products/new-product/components/FormField";
import TextField from "@mui/material/TextField";

// Material Dashboard 2 PRO React components
import MDBox from "../../../components/MDBox";
import MDInput from "../../../components/MDInput";

import { directPaymentEnum } from "../../../config/enum";

export default function Infos({
  deviceId,
  invoiceProcedure,
  setInvoiceProcedure,
  directPayment,
  setDirectPayment,
  directPaymentAmount,
  setDirectPaymentAmount,
  tva,
  setTva,
}) {
  return (
    <MDBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormField
            value={invoiceProcedure}
            onChange={(event) => setInvoiceProcedure(event.target.value)}
            type="text"
            minRows={2}
            inputProps={{ maxLength: 255 }}
            multiline="true"
            variant="outlined"
            label="Procédure d'envoi des factures"
          />
        </Grid>
        <Grid item xs={directPayment === "Oui" ? 4 : 6}>
          <Autocomplete
            options={directPaymentEnum}
            value={directPayment}
            onChange={(event, newDirectPayment) => {
              setDirectPayment(newDirectPayment);
            }}
            renderInput={(params) => (
              <MDInput {...params} label="Paiement direct" variant="standard" />
            )}
          />
        </Grid>
        {directPayment === "Oui" && (
          <Grid item xs={4}>
            <TextField
              value={directPaymentAmount}
              onChange={(event) => setDirectPaymentAmount(event.target.value)}
              label="Montant du paiement direct (en €)"
              fullWidth
              type="number"
              inputProps={{ maxLength: 255 }}
            />
          </Grid>
        )}
        <Grid item xs={directPayment === "Oui" ? 4 : 6}>
          <FormField
            value={tva}
            onChange={(event) => setTva(event.target.value)}
            variant="outlined"
            type="number"
            label="TVA (en %)"
            inputProps={{ maxLength: 255 }}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}
